import React, { useEffect } from 'react'
import './Calendar.sass'
import withStore from '../../Components/Unstated/withStore'
import CalendarStore from './Store/CalendarStore'
import WeekControls from './Components/WeekControls'
import DayMarkers from './Components/DayMarkers'
import Slots from './Components/Slots'
import Loading from '../../Components/Loading/Loading'

const Calendar = ({
  type,
  teacherSlots,
  slotDuration = 60,
  calendarStore: {
    state: { loaded },
    initTeacherMarkingCalendar,
    initMyCalendar,
    init,
  },
  topBarMessage,
  slots,
  livDemyID,
  courseInfo,
  onChange,
}) => {
  useEffect(() => {
    if (type === 'becomeTeacherCalendar') {
      initTeacherMarkingCalendar(teacherSlots, onChange)
    } else if (type === 'myCalendar') {
      initMyCalendar(slots, onChange)
    } else {
      init(livDemyID, slots, courseInfo, slotDuration)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    livDemyID,
    initTeacherMarkingCalendar,
    initMyCalendar,
    init,
    courseInfo,
    onChange,
    slotDuration,
    teacherSlots,
    type,
  ])

  return loaded ? (
    <div className='calendar'>
      <WeekControls topBarMessage={topBarMessage} />
      <DayMarkers />
      <Slots />
    </div>
  ) : (
    <Loading full />
  )
}

export default withStore([CalendarStore])(Calendar)
